/** Hand a downloaded file to the browser under its own name: the list CSV,
 *  from the list page's "Export CSV" and the index row's download icon. */
export function saveBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
